// extracted by mini-css-extract-plugin
export default {"constraintsWrapperContainer":"constraintsWrapper_constraintsWrapperContainer__rQ-q+","title":"constraintsWrapper_title__JyXXE"};